let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4hyAA")).then(() => parcelRequire('4YQfr'));